module.exports = __webpack_public_path__ + "static/media/generic-preview.cdcbc0ba.png";